import { debounceEvent, detectMobile } from '../../../js/utils';
import Splide from "@splidejs/splide";

export default class FooterBenefits {
  setCarouselState(carousel) {
    const isMobile = detectMobile();

    carousel.options = {
      type   : isMobile ? 'loop' : 'slide',
      rewind : isMobile ? 'true' : 'false',
      drag   : isMobile ? 'true' : 'false',
      perPage: isMobile ? 1 : 5
    };

    carousel.destroy();
    carousel.mount();
  }

  init() {
    const footerBenefitsCarouselSelector = '.js-swa-footer-benefits';
    const footerBenefitsCarouselElement = document.querySelector(footerBenefitsCarouselSelector);
    const footerBenefitsCarouselSlidesSelector = '.js-swa-footer-benefits .splide__slide';

    if (!document.querySelector(footerBenefitsCarouselSelector) || !document.querySelector(footerBenefitsCarouselSlidesSelector)) {
      return;
    }

    let footerBenefitsCarousel = new Splide(footerBenefitsCarouselSelector, {
      perMove    : 1,
      pagination : false,
      rewind     : true,
      speed      : 650,
      rewindSpeed: 1500,
      clones     : 0,
      cloneStatus: false
    });

    window.classSplide = Splide;
    const track = footerBenefitsCarouselElement.querySelector('.splide__track');
    const list = footerBenefitsCarouselElement.querySelector('.splide__list');
    const slide = footerBenefitsCarouselElement.querySelector('.splide__slide');
    if (track && list && slide) {
      footerBenefitsCarousel.mount();
    } else {
      console.log("==================SPLIDE DOES NOT HAVE LIST OR TRACK OR Slide===============");
    }

    // Determine whether the carousel should be scrollable or static on window resize
    window.addEventListener(
      'resize',
      debounceEvent(() => this.setCarouselState(footerBenefitsCarousel), 500)
    );
  }
}
